"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelEffectsEventHandlerActivator = exports.CancelEffectsEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class CancelEffectsEventHandlerArgs {
    constructor(effectIds) {
        this.effectIds = effectIds;
        this.__type = EventHandlerType_1.EventHandlerType.CancelEffects;
        this.__typeName = "CancelEffects";
    }
}
exports.CancelEffectsEventHandlerArgs = CancelEffectsEventHandlerArgs;
let CancelEffectsEventHandlerActivator = class CancelEffectsEventHandlerActivator {
    activate(sequence, container, handler) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of handler.args.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
CancelEffectsEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.CancelEffects)
], CancelEffectsEventHandlerActivator);
exports.CancelEffectsEventHandlerActivator = CancelEffectsEventHandlerActivator;
